import Logo from "components/common/Logo";
import TryForFreeButton from "components/common/TryForFreeButton";
import SignInButton from "components/common/SignInButton";
import { useEffect, useState } from "react";

interface Props {
  enableVisibilityOnScroll?: boolean;
}

export default function NavigationBar(props: Props) {
  const { enableVisibilityOnScroll } = props;
  const [displayNav, setDisplayNav] = useState(false);
  const [scrollHeightToActivateNavigation] = useState(200);

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > scrollHeightToActivateNavigation) {
        if (!displayNav) {
          setDisplayNav(true);
        }
      } else {
        if (displayNav) {
          setDisplayNav(false);
        }
      }
    };

    if (enableVisibilityOnScroll) {
      window.addEventListener("scroll", handleScroll);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [displayNav, enableVisibilityOnScroll, scrollHeightToActivateNavigation]);

  return displayNav || !enableVisibilityOnScroll ? (
    <div className="py-3">
      <Logo />
      <div className="float-right mt-3">
        <SignInButton />
        <div className="hidden sm:inline-block">
          <TryForFreeButton />
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
}
